import { Plugin } from '@jeppesen-foreflight/jmkw-types';
import { ThemeButtonComponent } from './theme-button/theme-button.component';

export const THEME_PLUGIN: Plugin = new Plugin({
  id: 'theme',
  button: {
    buttonComponent: ThemeButtonComponent
  }
});
